<section>
  <header>
    <h1 class="f-18">Você não está logado!</h1>
    <i icon="close" class="icons_close" (click)="closePopup()"></i>
  </header>

  <p class="f-16">Para realizar a compra é necessário estar logado.</p>

  <div class="card_buttons">
    <button mat-button class="btn_no f-12" (click)="closePopup()">
      FECHAR
    </button>
    <button mat-button class="btn_yes f-12" (click)="LogIn()">
      FAZER LOGIN
    </button>
  </div>
</section>

<!-- <div class="modal-content">
  <div class="modal-header">
    <h1>Você não está logado!</h1>

    <svg
      (click)="closePopup()"
      class="icons_close"
      width="25px"
      height="25px"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
      />
    </svg>
  </div>

  <div class="modal-body">
    <div
      style="
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      "
    >
      <h2>Para realizar a compra é necessário estar logado.</h2>
    </div>
  </div>

  <div class="card_buttons">
    <button mat-button class="btn_no" (click)="closePopup()">FECHAR</button>
    <button mat-button class="btn_yes" (click)="LogIn()">FAZER LOGIN</button>
  </div>
</div> -->
